module.exports = __webpack_public_path__ + "img/bitcoin.2a5139b4.png";